import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FileSortFields } from '../../enums/file-sort-fields.enum';
import { IFileSort } from '../../interfaces/file-sort.interface';

type SortType = { name: string, value: FileSortFields, icon: string };

@Component({
  selector: 'app-file-browser-sort',
  templateUrl: './file-browser-sort.component.html',
  styleUrls: ['./file-browser-sort.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileBrowserSortComponent implements OnInit {
  @Input() sort: IFileSort;
  @Output() sortChange = new EventEmitter<IFileSort>();
  
  protected selected: SortType | undefined;
  
  protected sortTypes: SortType[] = [
    { name: 'my-files.sort-by-name', value: FileSortFields.NAME, icon: 'list-outline' },
    { name: 'my-files.sort-by-size', value: FileSortFields.SIZE, icon: 'hard-drive-outline' },
    { name: 'my-files.sort-by-date', value: FileSortFields.CREATED_AT, icon: 'calendar-outline' }
  ];
  
  constructor(
    private changeDetector: ChangeDetectorRef
  ) { }
  
  protected get icon(): string {
    return this.sort?.direction === 'asc' ? 'arrow-up' : 'arrow-down';
  }

  ngOnInit(): void {
    if (this.sort?.field) {
      this.selected = this.sortTypes.find(sortType => sortType.value === this.sort.field);
      return;
    }

    this.selected = this.sortTypes[0];
  }

  ngOnChanges(changes: SimpleChanges): void {
    const field = changes['sort'].currentValue.field;
    this.selected = this.sortTypes.find(sortType => sortType.value === field);
  }

  protected sortBy(sortType: SortType): void {
    const newSort: IFileSort = { field: sortType.value, direction: 'asc' };
    
    newSort.field = sortType.value;
    
    if (sortType.value === this.sort.field) {
      newSort.direction = this.sort.direction === 'asc' ? 'desc' : 'asc';
    } else {
      newSort.direction = 'asc';
    }
    
    this.sort = newSort;
    this.selected = sortType;
    this.sortChange.emit(this.sort);
  }
}
